import React, { Fragment, useMemo, useRef } from 'react';
import T from 'prop-types';
import { Provider } from 'react-redux';

import QuickView from './QuickView';
import QuickViewContext from './QuickViewContext';

import {
  openAppQuickView,
  openPubQuickView,
  openCompanyQuickView,
  changeAdditionalParams,
} from './actions';
import reducer from './reducer';
import { makeDefaultState } from './store';
import createStore from '../../store/create-store';
import { getGlobalSettings } from '../../utils/global_settings';

const QuickViewProvider = ({ children, enableCloseOutside, permissions = {} }) => {
  const globalSettings = getGlobalSettings();

  const { current: combinedPermissions } = useRef({
    ...globalSettings.permissions,
    ...permissions,
  });

  const { current: store } = useRef(createStore(reducer, makeDefaultState(combinedPermissions)));

  const actions = useMemo(() => {
    const onAppQuickViewOpen = (app) => {
      store.dispatch(openAppQuickView(app));
    };

    const onPubQuickViewOpen = (pub) => {
      store.dispatch(openPubQuickView(pub));
    };

    const onCompanyQuickViewOpen = (company) => {
      store.dispatch(openCompanyQuickView(company));
    };

    const onChangeAdditionalParams = (params) => {
      store.dispatch(changeAdditionalParams(params));
    };

    return {
      onAppQuickViewOpen,
      onPubQuickViewOpen,
      onCompanyQuickViewOpen,
      onChangeAdditionalParams,
    };
  }, []);

  return (
    <Fragment>
      <Provider store={store}>
        <QuickView enableCloseOutside={enableCloseOutside} />
      </Provider>
      <QuickViewContext.Provider value={actions}>{children}</QuickViewContext.Provider>
    </Fragment>
  );
};

QuickViewProvider.propTypes = {
  children: T.node.isRequired,
  enableCloseOutside: T.bool,
  permissions: T.object,
};

export default QuickViewProvider;
